






























import { MiaPlaza } from "@/Reinforced.Typings";
import ResponsiveImage from "@/Control/Vue/ResponsiveImage";
import { Component } from "vue-property-decorator";
import Item from "../Lists/VueList/Items/Item";
import { DefaultShopCompetitionItem } from "../Defaults"
import ShopLogo from 'theme/miniworld/navigation/shopping-cart-simple.svg';
import HouseLogo from 'theme/miniworld/navigation/house-simple.svg';

@Component({
	components: {
		ResponsiveImage
	}
})
export default class ShopCompetitionItem extends Item<MiaPlaza.Controllers.Shop.IShopWithCustomers> { 
	protected defaults = DefaultShopCompetitionItem;
	private readonly shopLogo = ShopLogo;
	private readonly houseLogo = HouseLogo;
}
